import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'
import userInfoUtil from '@/utils/userInfoUtil'

export default {
  // 获取表格过滤设置信息
  getFilterInfo: async function (tableCode) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableFilter.GetTableFilters', {
      tableCode: tableCode
    })
    if (rtnObj.error === '000000') {
      return {
        error: '000000',
        filterInfo: rtnObj.tableFilters
      }
    } else {
      return rtnObj
    }
  },

  // 刷新过滤信息
  refreshTableFliter: async function (that, tableName) {
    const table = that[tableName]
    table.FilterLoading = true
    const tableFilter = await this.getFilterInfo(table.tableCode)
    if (tableFilter.error === '000000') {
      table.filterInfo = tableFilter.filterInfo
      for (let i = 0; i < tableFilter.filterInfo.length; i++) {
        if (tableFilter.filterInfo[i].DataType === '0') {
          if (tableFilter.filterInfo[i].DefaultVal1Type === '2') {
            tableFilter.filterInfo[i].DefaultVal1 = userInfoUtil.getUserCode()
          }
          if (tableFilter.filterInfo[i].DefaultVal2Type === '2') {
            tableFilter.filterInfo[i].DefaultVal2 = userInfoUtil.getUserCode()
          }
        } else if (tableFilter.filterInfo[i].DataType === '4') {
          if (tableFilter.filterInfo[i].DefaultVal1Type === '1') {
            tableFilter.filterInfo[i].DefaultVal1 = new Date()
          }
          if (tableFilter.filterInfo[i].DefaultVal2Type === '1') {
            tableFilter.filterInfo[i].DefaultVal2 = new Date()
          }
        }
      }
    } else {
      that.$message.error(tableFilter.msg)
    }
    table.FilterLoading = false
  },

  // 显示过滤弹框
  showTableFliter: async function (that, tableName) {
    const table = that[tableName]
    table.showFilterDialog = true
    table.changeShowFilterDialog = !table.changeShowFilterDialog
    if (table.filterInfo.length > 0) {
      return
    }
    this.refreshTableFliter(that, tableName)
  },

  // 过滤并刷新页面数据
  filter: function (that, tableName) {
    let filterStr = ''
    const table = that[tableName]
    table.page = 1
    for (let i = 0; i < table.filterInfo.length; i++) {
      const oneFilter = table.filterInfo[i]
      const filterType = oneFilter.FilterType
      const defaultVal1 = oneFilter.DefaultVal1
      const defaultVal2 = oneFilter.DefaultVal2
      const columnCode = oneFilter.ColumnCode
      const dataType = oneFilter.DataType
      const dateFormat = oneFilter.DateFormat
      const type = oneFilter.Type
      if (dataType === '0') {
        if (filterType === '00') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' OR ' + columnCode + "='" + filterStrAry[i] + "'"
            }
            filterStr += ')'
          }
        } else if (filterType === '01') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=1 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' AND ' + columnCode + "!='" + filterStrAry[i] + "'"
            }
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '10') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              if (filterStrAry[i].length > 2 && filterStrAry[i].substr(0, 1) === '[' && filterStrAry[i].substr(filterStrAry[i].length - 1) === ']') {
                filterStr += ' OR ' + columnCode + " LIKE '" + filterStrAry[i].substr(1, filterStrAry[i].length - 2) + "'"
              } else {
                filterStr += ' OR ' + columnCode + " LIKE '%" + filterStrAry[i] + "%'"
              }
            }
            filterStr += ')'
          }
        } else if (filterType === '11') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              if (filterStrAry[i].length > 2 && filterStrAry[i].substr(0, 1) === '[' && filterStrAry[i].substr(filterStrAry[i].length - 1) === ']') {
                filterStr += ' OR ' + columnCode + " NOT LIKE '" + filterStrAry[i].substr(1, filterStrAry[i].length - 2) + "'"
              } else {
                filterStr += ' OR ' + columnCode + " NOT LIKE '%" + filterStrAry[i] + "%'"
              }
            }
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '12') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' OR ' + columnCode + " LIKE '" + filterStrAry[i] + "%'"
            }
            filterStr += ')'
          }
        } else if (filterType === '13') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' OR ' + columnCode + " LIKE '%" + filterStrAry[i] + "'"
            }
            filterStr += ')'
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL OR ' + columnCode + "='')"
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL AND ' + columnCode + "!='')"
            }
          }
        }
      } else if (dataType === '1') {
        if (filterType === '00') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '=' + defaultVal1
          }
        } else if (filterType === '01') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '!=' + defaultVal1
          }
        } else if (filterType === '10') {
          if ((defaultVal1 || defaultVal1 === 0) || (defaultVal2 || defaultVal2 === 0)) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            if ((defaultVal1 || defaultVal1 === 0) && (defaultVal2 || defaultVal2 === 0)) {
              filterStr += ' (' + columnCode + '>=' + defaultVal1 + ' AND'
              filterStr += ' ' + columnCode + '<=' + defaultVal2 + ')'
            } else {
              if (defaultVal1 || defaultVal1 === 0) {
                filterStr += ' ' + columnCode + '>=' + defaultVal1 + ''
              } else {
                filterStr += ' ' + columnCode + '<=' + defaultVal2 + ''
              }
            }
          }
        } else if (filterType === '11') {
          if ((defaultVal1 || defaultVal1 === 0) || (defaultVal2 || defaultVal2 === 0)) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            if ((defaultVal1 || defaultVal1 === 0) && (defaultVal2 || defaultVal2 === 0)) {
              filterStr += ' (' + columnCode + '<' + defaultVal1 + ' OR'
              filterStr += ' ' + columnCode + '>' + defaultVal2 + ')'
            } else {
              if (defaultVal1 || defaultVal1 === 0) {
                filterStr += ' ' + columnCode + '<' + defaultVal1 + ''
              } else {
                filterStr += ' ' + columnCode + '>' + defaultVal2 + ''
              }
            }
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL)'
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL)'
            }
          }
        } else if (filterType === '20') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '>' + defaultVal1
          }
        } else if (filterType === '21') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '>=' + defaultVal1
          }
        } else if (filterType === '22') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '<' + defaultVal1
          }
        } else if (filterType === '23') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '<=' + defaultVal1
          }
        }
      } else if (dataType === '2') {
        if (filterType === '00') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '=' + defaultVal1
          }
        } else if (filterType === '01') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '!=' + defaultVal1
          }
        } else if (filterType === '10') {
          if ((defaultVal1 || defaultVal1 === 0) || (defaultVal2 || defaultVal2 === 0)) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            if ((defaultVal1 || defaultVal1 === 0) && (defaultVal2 || defaultVal2 === 0)) {
              filterStr += ' (' + columnCode + '>=' + defaultVal1 + ' AND'
              filterStr += ' ' + columnCode + '<=' + defaultVal2 + ')'
            } else {
              if (defaultVal1 || defaultVal1 === 0) {
                filterStr += ' ' + columnCode + '>=' + defaultVal1 + ''
              } else {
                filterStr += ' ' + columnCode + '<=' + defaultVal2 + ''
              }
            }
          }
        } else if (filterType === '11') {
          if ((defaultVal1 || defaultVal1 === 0) || (defaultVal2 || defaultVal2 === 0)) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            if ((defaultVal1 || defaultVal1 === 0) && (defaultVal2 || defaultVal2 === 0)) {
              filterStr += ' (' + columnCode + '<' + defaultVal1 + ' OR'
              filterStr += ' ' + columnCode + '>' + defaultVal2 + ')'
            } else {
              if (defaultVal1 || defaultVal1 === 0) {
                filterStr += ' ' + columnCode + '<' + defaultVal1 + ''
              } else {
                filterStr += ' ' + columnCode + '>' + defaultVal2 + ''
              }
            }
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL)'
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL)'
            }
          }
        } else if (filterType === '20') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '>' + defaultVal1
          }
        } else if (filterType === '21') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '>=' + defaultVal1
          }
        } else if (filterType === '22') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '<' + defaultVal1
          }
        } else if (filterType === '23') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '<=' + defaultVal1
          }
        }
      } else if (dataType === '3') {
        if (filterType === '00') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' ' + columnCode + '=' + defaultVal1
          }
        } else if (filterType === '01') {
          if (defaultVal1 || defaultVal1 === 0) {
            if (type === '1') {
              filterStr += ' AND('
            } else {
              filterStr += ' OR('
            }
            filterStr += ' ' + columnCode + '!=' + defaultVal1
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL)'
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL)'
            }
          }
        }
      } else if (dataType === '4') {
        if (filterType === '00') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")='" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "'"
          }
        } else if (filterType === '01') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND('
            } else {
              filterStr += ' OR ('
            }
            filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")!='" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "'"
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '10') {
          if (defaultVal1 || defaultVal2) {
            if (type === '1') {
              filterStr += ' AND'
            } else {
              filterStr += ' OR'
            }
            if (defaultVal1 && defaultVal2) {
              filterStr += ' (SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")>='" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "' AND"
              filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")<='" + dateTimeUtil.formartDateTime(defaultVal2, dateFormat) + "')"
            } else {
              if (defaultVal1) {
                filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")>='" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "'"
              } else {
                filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")<='" + dateTimeUtil.formartDateTime(defaultVal2, dateFormat) + "'"
              }
            }
          }
        } else if (filterType === '11') {
          if (defaultVal1 || defaultVal2) {
            if (type === '1') {
              filterStr += ' AND ('
            } else {
              filterStr += ' OR ('
            }
            if (defaultVal1 && defaultVal2) {
              filterStr += ' (SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")<'" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "' OR"
              filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")>'" + dateTimeUtil.formartDateTime(defaultVal2, dateFormat) + "')"
            } else {
              if (defaultVal1) {
                filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")<'" + dateTimeUtil.formartDateTime(defaultVal1, dateFormat) + "'"
              } else {
                filterStr += ' SUBSTRING(CONVERT(VARCHAR,' + columnCode + ',21),1,' + dateFormat.length + ")>'" + dateTimeUtil.formartDateTime(defaultVal2, dateFormat) + "'"
              }
            }
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL)'
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL)'
            }
          }
        }
      } else if (dataType === '5') {
        if (filterType === '00') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            filterStr += ' ' + columnCode + "='" + defaultVal1 + "'"
          }
        } else if (filterType === '01') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND ('
            } else {
              filterStr += ' OR ('
            }
            filterStr += ' ' + columnCode + "!='" + defaultVal1 + "'"
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '10') {
          if (defaultVal1 && defaultVal1.length > 0) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.toString().replace(/，/g, ',').split(',')
            filterStr += '(1=0 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' OR ' + columnCode + "='" + filterStrAry[i] + "'"
            }
            filterStr += ')'
          }
        } else if (filterType === '11') {
          if (defaultVal1 && defaultVal1.length > 0) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            const filterStrAry = defaultVal1.toString().replace(/，/g, ',').split(',')
            filterStr += '(1=1 '
            for (let i = 0; i < filterStrAry.length; i++) {
              filterStr += ' AND ' + columnCode + "!='" + filterStrAry[i] + "'"
            }
            filterStr += ' OR ' + columnCode + ' IS NULL)'
          }
        } else if (filterType === '14') {
          if (defaultVal1) {
            if (type === '1') {
              filterStr += ' AND '
            } else {
              filterStr += ' OR '
            }
            if (defaultVal1 === '1') {
              filterStr += ' (' + columnCode + ' IS NULL OR ' + columnCode + "='')"
            } else if (defaultVal1 === '0') {
              filterStr += ' (' + columnCode + ' IS NOT NULL AND ' + columnCode + "!='')"
            }
          }
        }
      }
    }
    table.showFilterDialog = false
    table.changeShowFilterDialog = !table.changeShowFilterDialog
    table.filterStr = filterStr
    that['refresh' + tableName.substr(0, 1).toUpperCase() + tableName.substr(1) + 'Content']()
  }
}
